import z from 'zod';
import { CreateNotePayload } from '../models/note';
import { createNotePayloadSchema } from '../models/note.schema';

export const create = (payload: CreateNotePayload) => {
  return {
    endpoint: `/notes`,
    method: 'POST',
    payload,
    responseSchema: z.unknown(),
    payloadSchema: createNotePayloadSchema,
  } as const;
};
